import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { ManagedContentService } from "../shared/service/managed-content.service";
import {
  CmSection,
  ContentType,
} from "../shared/model/cm/managed-content.model";
import { ProgressBarSection } from "../shared/model/progress-bar-object";
import { ViewportScroller } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ReactiveFormsModule } from "@angular/forms";

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProgressBarComponent implements OnInit, OnChanges {
  @Input() currentStep: number = 1;
  @Input() totalSteps: number = 3;
  @Input() completedSteps: boolean[] = [];
  @Output() stepChanged = new EventEmitter<number>();

  public activeIndex = 0;
  public progressBarHeaderTitle = "Medical History Statement";

  public progressBarSteps: ProgressBarSection[] = [];

  private employeeSection: CmSection;
  private applicantSection: CmSection;
  private medicalHistorySection: CmSection;
  private physicianSection: CmSection;
  private authorizationSection: CmSection;
  private authorizationUseReleaseSection: CmSection;

  constructor(private cmService: ManagedContentService,
              private scroller: ViewportScroller) {}

  ngOnInit(): void {
    this.activeIndex = this.currentStep - 1;

    this.employeeSection = this.cmService.getContentById(
      ContentType.SECTION,
      "employee-section"
    );
    this.applicantSection = this.cmService.getContentById(
      ContentType.SECTION,
      "applicant-section"
    );
    this.medicalHistorySection = this.cmService.getContentById(
      ContentType.SECTION,
      "medical-history-section"
    );
    this.physicianSection = this.cmService.getContentById(
      ContentType.SECTION,
      "physician-section"
    );

    this.progressBarSteps = [
      {
        title: this.employeeSection.title,
        url: "/employee-information",
        keyid: this.employeeSection.id,
      },
      {
        title: this.applicantSection.title,
        url: "/applicant-information",
        keyid: this.applicantSection.id,
      },
      {
        title: this.medicalHistorySection.title,
        url: "/medical-history",
        keyid: this.medicalHistorySection.id,
      },
      {
        title: this.physicianSection.title,
        url: "/physician-information",
        keyid: this.physicianSection.id,
      }
    ];

    if(this.totalSteps == 4){
      this.progressBarSteps.push({
        title: "Electronic Communication",
        url: "/authorization-use-release-info",
        keyid: "authorization-use-release-info"
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["currentStep"] &&
      changes["currentStep"].currentValue !==
        changes["currentStep"].previousValue
    ) {
      this.activeIndex = this.currentStep - 1;
      this.onScrollToTop();
    }
  }
  onScrollToTop(){
    this.scroller.setOffset([0, 200]);
    this.scroller.scrollToAnchor('topOfPage');
  }

  getProgressBarState(index: number): string {
    const lastCompletedIndex = this.completedSteps.lastIndexOf(true);

    if (this.completedSteps[index] === true){
      return "complete";
    }else if (index === this.activeIndex){
      // Current active step is always in-progress
      return "in-progress";
    }else if (index === lastCompletedIndex + 1){
      // Next step after last completed is always in-progress
      // This shows the logical next step in the workflow
      return "in-progress";
    }else{
      return "inactive";
    }
  }

  onStepClick(step: number) {
    if (this.getProgressBarState(step) === "complete" || this.getProgressBarState(step) === "in-progress") {
      this.stepChanged.emit(step + 1);
    }
  }
}
